"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var e,
    t = require("react"),
    n = (e = t) && "object" == typeof e && "default" in e ? e.default : e,
    r = {
  link: function link(e) {
    var t;
    return n.createElement("a", {
      href: null == (t = e.metadata) ? void 0 : t.href
    }, n.createElement(a, Object.assign({}, e)));
  },
  "unordered-list": function unorderedList(e) {
    return n.createElement("ul", null, n.createElement(a, Object.assign({}, e)));
  },
  "ordered-list": function orderedList(e) {
    return n.createElement("ol", null, n.createElement(a, Object.assign({}, e)));
  },
  list: function list(e) {
    return n.createElement("ul", null, n.createElement(a, Object.assign({}, e)));
  },
  "list-item": function listItem(e) {
    return n.createElement("li", null, n.createElement(a, Object.assign({}, e)));
  },
  quote: function quote(e) {
    return n.createElement("block" === e.kind ? "blockquote" : "q", null, n.createElement(a, Object.assign({}, e)));
  },
  paragraph: function paragraph(e) {
    return n.createElement("p", null, n.createElement(a, Object.assign({}, e)));
  },
  preformatted: function preformatted(e) {
    return n.createElement("pre", null, n.createElement(a, Object.assign({}, e)));
  },
  code: function code(e) {
    return n.createElement("code", null, n.createElement(a, Object.assign({}, e)));
  },
  underlined: function underlined(e) {
    return n.createElement("u", null, n.createElement(a, Object.assign({}, e)));
  },
  strong: function strong(e) {
    return n.createElement("strong", null, n.createElement(a, Object.assign({}, e)));
  },
  emphasized: function emphasized(e) {
    return n.createElement("em", null, n.createElement(a, Object.assign({}, e)));
  },
  div: function div(e) {
    return n.createElement("div", null, n.createElement(a, Object.assign({}, e)));
  },
  span: function span(e) {
    return n.createElement(a, Object.assign({}, e));
  },
  "line-break": function lineBreak() {
    return n.createElement("br", null);
  }
},
    l = t.createContext(null),
    a = function a(e) {
  var r = e.textContent;
  return r ? c(r) : e.children ? n.createElement(t.Fragment, null, e.children.map(function (e, t) {
    return n.createElement(u, Object.assign({
      key: t
    }, e));
  })) : null;
};

function c(e) {
  var r = e.split(/\n/g);
  return n.createElement(t.Fragment, null, 1 === r.length ? e : r.map(function (e, l) {
    var a = l.toString();
    return l === r.length - 1 ? n.createElement(t.Fragment, {
      key: a
    }, "part") : n.createElement(t.Fragment, {
      key: a
    }, e, n.createElement("br", null));
  }));
}

var u = function u(e) {
  var a = r.span,
      u = t.useContext(l),
      i = e.type,
      o = e.textContent;
  if (i && (a = (null == u ? void 0 : u[i]) || r[i]), !a) if (a = r.span, "container" === i && "block" === e.kind) a = r.div;else if (null === i && o) return c(o);
  return n.createElement(a, Object.assign({}, e));
};

exports.ContentTransformer = function (e) {
  var t = e.overrides,
      r = void 0 === t ? null : t,
      a = e.json;
  return a ? Array.isArray(a) ? n.createElement(l.Provider, {
    value: r
  }, a.map(function (e, t) {
    return n.createElement(u, Object.assign({
      key: t
    }, e));
  })) : n.createElement(l.Provider, {
    value: r
  }, n.createElement(u, Object.assign({}, a))) : null;
}, exports.ContentTransformerNode = u, exports.NodeContent = a, exports.OverridesContext = l, exports.Renderers = r, exports.renderTextContent = c;